import { registerPlugin, mergeConfig } from '@modern-js/runtime/plugin';
import { getGlobalAppConfig, getGlobalLayoutApp, getCurrentEntryName } from '@modern-js/runtime/context';

import modernRuntime from '@_modern_js_src/modern.runtime';
const runtimeConfig = typeof modernRuntime === 'function' ? modernRuntime(getCurrentEntryName()) : modernRuntime

const plugins = [];

import { routerPlugin } from '@modern-js/runtime/router/internal';

plugins.push(routerPlugin(mergeConfig({"serverBase":["/"]}, (runtimeConfig || {})['router'], ((runtimeConfig || {})['routerByEntries'] || {})['main'], (getGlobalAppConfig() || {})['router'])));

registerPlugin(plugins, runtimeConfig);
